module.exports = __webpack_public_path__ + "img/taylorBellCastingHall201027-242.9ee819f8.jpg";